<template>
  <div
    class="icon-grid"
    @click="clicked"
  >
    <div>
      <img :src="icon" />
    </div>
    <div>
      {{ label }}
    </div>
  </div>
</template>

<script>
import weui from "weui.js";

export default {
  props: {
    icon: String,
    label: String,
    url: String
  },
  data() {
    return {
      userInfo: {}
    };
  },
  methods: {
    clicked() {
      if (!this.$store.state.User.userInfo) {
        weui.alert("获取用户信息失败");
      } else {
        this.userInfo = this.$store.state.User.userInfo;
        if (this.url) {
          if (
            this.url.indexOf("/expressTotakein") == 0 &&
            !this.userInfo.idCardNo &&
            !this.userInfo.toAuthIdCardNo
          ) {
            this.$router.push(
              "/authApply/0/expressTotakein/" +
                sessionStorage.getItem("encodeToken")
            );
          } else if (
            (this.url.indexOf("/robbing") == 0 ||
              this.url.indexOf("/robbingList") == 0) &&
            this.userInfo.paotuiStatus != 1
          ) {
            this.$router.push(
              "/paotuiApply/" + sessionStorage.getItem("encodeToken")
            );
          }
          this.$router.push(this.url);
        }
      }
    }
  }
};
</script>

<style scoped>
.icon-grid {
  padding: 0.5rem;
  box-sizing: border-box;
  text-align: center;
  font-size: 0.8rem;
}

.icon-grid > div {
  margin-bottom: 0.5rem;
}

.icon-grid img {
  width: 30px;
  height: 30px;
}
</style>




// WEBPACK FOOTER //
// src/components/home/IconGrid.vue